import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import { lazy, Suspense, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { Box, CircularProgress, CssBaseline } from '@mui/material';
import NavBar from './components/Navbar';
import FixedBtn from './components/global/FixedBtn';
import Footer from './components/Footer/Footer';
import NotFound from './pages/NotFound';
import TopBar from './components/Navbar/TopBar';
import { useWebsiteSettings } from './hooks/useWebsiteSettings';

const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const Agencies = lazy(() => import("./pages/Agencies"));
const AgencyDetail = lazy(() => import("./pages/AgencyDetail"));

const languages = [
    { code: 'ar', name: 'Ar', country_coode: 'sa', dir: 'rtl' },
    { code: 'en', name: 'En', country_coode: 'gb', dir: 'ltr' },
];

function App() {
    const { settings } = useWebsiteSettings();
    const currentLanguageCode = Cookies.get('i18next') || 'ar';
    const currentLanguage = useMemo(() => languages.find(l => l.code === currentLanguageCode), [currentLanguageCode]);
    const { t } = useTranslation();

    useEffect(() => {
        document.dir = currentLanguage.dir || 'rtl';
        document.getElementsByTagName('html')[0].setAttribute('lang', currentLanguage.code || 'ar');
    }, [currentLanguage, t]);

    const ScrollToTop = () => {
        const { pathname } = useLocation();
        useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
        return null;
    };

    return (
        <div className="App">
            <CssBaseline />
            <FixedBtn data={settings} />
            <TopBar data={settings} />
            <NavBar data={settings} />
            <ScrollToTop />
            <Suspense fallback={
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <CircularProgress />
                </Box>
            }>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<ContactUs />} />
                    <Route path="/agencies" element={<Agencies />} />
                    <Route path="/agencies/:slug" element={<AgencyDetail />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
            <Footer data={settings} />
        </div>
    );
}

export default App;
